module.exports = __webpack_public_path__ + "static/img/1-2.6c182892.png";